














import Vue from 'vue';
import { axiosApiInstance } from '../../utils/axiosInstances';
import VueJsonEditor from 'vue-json-editor';

interface label {
  labelId: string;
  label: any;
}

export default Vue.extend({
  props: ['labelId'],
  components: { VueJsonEditor },
  data(): {
    labelData: label;
    newLabelData: any;
    labelKeys: string[];
    errorFlag: boolean;
    error: string;
  } {
    return {
      labelData: {
        labelId: '',
        label: {},
      },
      newLabelData: {},
      labelKeys: [],
      errorFlag: false,
      error: '새로운 key가 존재하면 Label Data를 수정할 수 없습니다.',
    };
  },
  watch: {
    labelId: async function (labelId) {
      this.labelData.labelId = labelId;
      const result = await this.getLabelData(labelId);
      const data = result.data.result;
      this.labelData.labelId = labelId;
      this.labelData.label = data.label;
    },
  },
  async created() {
    const result = await this.getLabelData(this.labelId);
    const data = result.data.result;
    this.labelData.labelId = data.label_id;
    this.labelData.label = data.label;

    this.labelKeys = Object.keys(this.labelData.label);
  },
  methods: {
    async getLabelData(labelId: string) {
      return await axiosApiInstance.get(
        `/api/v1/labelsets/${this.$route.params.labelsetId}/labels/${labelId}`,
      );
    },
    async updateLabelData() {
      this.errorFlag = false;
      let newLabelKeys: string[] = [];
      newLabelKeys = Object.keys(this.labelData.label);

      if (JSON.stringify(this.labelKeys) !== JSON.stringify(newLabelKeys)) {
        this.errorFlag = true;
        return;
      }

      const labelId = this.labelData.labelId;

      // const result = await axiosApiInstance.patch(
      //   `/api/v1/labelsets/${this.$route.params.labelsetId}/labels/${labelId}`,
      //   {
      //     label: this.labelData.label,
      //   },
      // );

      // label data가 수정이 된 후의 로직
      this.$emit('next');
    },
    onJsonChange(value: JSON) {
      this.errorFlag = false;
      this.labelData.label = value;
    },
  },
});
